/**
 * Adjuntos de pago
 *
 */
import React from 'react';
import { Table, Button, Modal } from 'antd';
import moment from 'moment';
import Cell from '../../../components/Cell';
import Api from '../../../Api';
import Exception from '../../../Exception';

export default class Adjuntos extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.columns = Cell.buildList([
      {
        title: 'NOMBRE', dataIndex: 'archivo.sDescripcion', width: '70%',
        render: (_, record) => <span>
          <a href={Api.to(`/upload/file/${record.iIdArchivo}`)} download={record.archivo.sDescripcion}>
            {record.archivo.sDescripcion}
          </a>
        </span>
      },
      { title: 'FECHA', dataIndex: 'archivo.dFechahora', width: '30%', render: val => moment(val).format('YYYY-MM-DD HH:mm:ss') }
    ]);

    this.state = {
      data: [],
      loading: false,
      pagoId: 0,
    };

    this.load = this.load.bind(this);
  }

  /**
   * Load
   *
   * @param {Number} pagoId
   */
  load(pagoId) {
    this.setState({
      visible: true,
      loading: true,
      data: [],
      pagoId: pagoId,
    });

    const query = {
      attributes: ['iId', 'iIdArchivo'],
      model: 'TesPagoAdjunto',
      include: [{ as: 'archivo', attributes: ['sDescripcion', 'dFechaHora'] }],
      where: {
        iIdPago: pagoId,
        iActivo: true
      }
    };

    Api.query(query)
      .then(response =>
        this.setState({
          loading: false,
          data: response.data,
        })
      )
      .catch(error => {
        this.setState({ loading: false });
        Exception.load(error).show();
      });
  }

  /**
   * Render
   *
   */
  render() {
    return (
      <Modal
        title='ADJUNTOS'
        visible={this.state.visible}
        onOk={this.onSave}
        style={{ minWidth: '70%' }}
        onCancel={() => this.setState({ visible: false })}
        footer={[
          <Button
            key='close'
            loading={this.state.loading}
            onClick={() => this.setState({ visible: false })}
            children='Cerrar'
          />
        ]}
        children={
          <Table
            key='2'
            rowKey='iId'
            size='small'
            loading={this.state.loading}
            columns={this.columns}
            pagination={false}
            dataSource={this.state.data}
            bordered={false}
          />
        }
      />
    );
  }
}
